import { globalVariables } from "helper/globalVariables";
import { useForm } from "react-hook-form";
import { Button } from "../../shared/Components/button";
import { TextInput } from "../../shared/Components/textInput";
import { signupResolver } from "validators/UserValidation";
import { useLayoutEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "helper/apolloConfig";
import { signupMutation } from "redux/features/authSlice/authGql";
import AuthLayout from "shared/Components/authLayout";
import { useDispatch, useSelector } from "react-redux";
import { setJudgeDetails } from "redux/features/judgeSlice/judgeSlice";
import { judgeUuid } from "container/MyProfile/Components/constants";

const SignUp = (props) => {
  const { isJudge } = props || {};
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: signupResolver,
    defaultValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
  });
  const modalRef = useRef();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [loading, setLoading] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state);

  useLayoutEffect(() => {
    if (isJudge) {
      getJudgeDetails();
    }
  }, [isJudge]);

  const getJudgeDetails = async () => {
    const judgeDetails = auth?.judgeReducer?.judgeDetails;
    if (judgeDetails) {
      setValue("name", judgeDetails?.username);
      setValue("email", judgeDetails?.email);
      setValue("password", judgeDetails?.password);
      setValue("confirmPassword", judgeDetails?.password);
    }
  };

  const handleSignup = async (credentials) => {
    const payload = {
      username: credentials?.name,
      email: credentials?.email,
      password: credentials?.password,
      // role: ["Member"],
    };

    if (isJudge) {
      dispatch(setJudgeDetails(payload));
      navigate(`/${judgeUuid}/basicDetails`);
    } else {
      setLoading(true);
      try {
        const result = await client.mutate({
          mutation: signupMutation,
          variables: { data: payload },
        });

        modalRef.current.openModal();
        if (result?.data?.registerUser) {
          setApiData({
            ...apiData,
            title: globalVariables.signUpSuccessful,
            desc: globalVariables.signUpSuccessfulDesc,
            type: "success",
            actionButton: {
              label: "Sign In",
              onClick: () => {
                navigate("/login");
                reset();
              },
            },
          });
        }
        setLoading(false);
      } catch (error) {
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: "Oops",
          desc: error?.message,
          type: "pending",
        });
        setLoading(false);
      }
    }
  };

  const onCloseModal = () => {
    if (apiData.type === "success") {
      navigate("/login");
      reset();
    }
  };

  return (
    <AuthLayout ref={modalRef} apiData={apiData} onCloseModal={onCloseModal}>
      <span className="pt-4 text-gray-900 font-semibold text-3xl">
        {globalVariables.createYourAccount}
      </span>
      <span className="pt-3 text-gray-500 font-regular text-base max-[358px]:w-[90%]">
        {globalVariables.startedEnterDetails}
      </span>
      <div className="mt-6" />
      <form
        onSubmit={handleSubmit(handleSignup)}
        className="flex flex-col justify-center items-center max-[400px]:w-[90%]"
      >
        <TextInput
          register={register}
          name="name"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.name}
          placeholder={globalVariables.enterName}
          errorMsg={errors.name?.message}
        />
        <div className="mt-4" />
        <TextInput
          register={register}
          name="email"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.email}
          placeholder={globalVariables.enterEmail}
          errorMsg={errors.email?.message}
          type="email"
          textTransform="normal-case"
        />
        <div className="mt-4" />
        <TextInput
          register={register}
          name="password"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.password}
          placeholder={globalVariables.tempPassword}
          errorMsg={errors.password?.message}
          type="password"
          textTransform="normal-case"
        />
        <div className="mt-4" />
        <TextInput
          register={register}
          name="confirmPassword"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.confirmPasswordSignUp}
          type="password"
          placeholder={globalVariables.tempPassword}
          errorMsg={errors.confirmPassword?.message}
          textTransform="normal-case"
        />
        <div className="mt-6" />
        <Button
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.createAccount}
          disabled={loading}
        />
      </form>
      <div className="mt-4" />
      <span className="text-sm text-gray-600 font-regular">
        {globalVariables.alreadyMember}
        <a href="/login">
          <span className="text-sm text-primary font-semibold">
            {` ${globalVariables.logIn}`}
          </span>
        </a>
      </span>
      {/* Todo:- Will use it later. */}
      {/* <div className="mt-6" />
          <span className="text-sm text-gray-600 font-regular">
            {globalVariables.byCreatingAnAccount}
          </span>
          <span className="text-sm text-primary font-semibold">
            {globalVariables.termsConditions}
            <span className="text-sm text-gray-600 font-regular">
              {` ${globalVariables.and} `}
            </span>
            {globalVariables.privacyPolicy}
          </span> */}
    </AuthLayout>
  );
};

export default SignUp;
